import { PrimaryCategories, Product } from 'store/product/types';
import { pushEvent } from 'helpers/utils/dataLayer';
import { events } from 'shared/constants/dataLayer';
import { NO_OFFER_ID, NO_OFFER_MESSAGE } from 'shared/constants';

interface NotifyMeData {
  product?: Product;
  brandName: string;
  productName: string;
  productId: string;
  offerPrice: number;
  primaryCategories: PrimaryCategories;
  isLux: number;
  offerMessage: string;
  offerId: string;
  pageSource?: string;
  trackingData?: string;
}

export const pushNotifyMe = ({
  product,
  brandName,
  productName,
  productId,
  primaryCategories,
  offerPrice,
  isLux,
  offerMessage = NO_OFFER_MESSAGE,
  offerId = NO_OFFER_ID,
  pageSource,
  trackingData,
  childId,
  discount,
  mrp,
  packSize,
  variantType,
}: NotifyMeData) => {
  if (!productId) {
    throw new Error('product id is mandatory');
  }
  const notifyMeSuccess = {
    variantName: productName,
    productId,
    categoryLevel: primaryCategories,
    brandName,
    offerPrice,
    isLux,
    pageSource,
    trackingData,
    childId,
    discount,
    mrp,
    packSize,
    variantType,
    ...product,
  };

  pushEvent(events.NOTIFY_ME_SUBMIT, {
    notifyMeSuccess,
    offerMessage,
    offerId,
  });
};
